import { createStore } from 'vuex';
import { getUserFingerprint, getVoteKey } from '@/utils';

const store = createStore({
  state () {
    return {
      votes: null,
      userFingerprint: null,
    }
  },

  mutations: {
    SET_VOTES(state, votes) {
      state.votes = {
        ...state.votes,
        ...votes
      };
    },

    SET_VOTE(state, { voteKey, vote }) {
      state.votes[voteKey] = vote;
    },

    SET_USER_FINGERPRINT(state, userFingerprint) {
      state.userFingerprint = userFingerprint;
    }
  },

  actions: {
    async fetchVotes({ state, commit }, statsApi) {
      commit('SET_USER_FINGERPRINT', await getUserFingerprint());

      const response = await statsApi.fetchVotes(
        state.userFingerprint
      );

      const body = await response.json();

      let votes = {};
      for (const vote of body) {
        const key = getVoteKey(vote.answer_id, vote.language);
        votes[key] = vote;
      }

      commit('SET_VOTES', votes);
    },

    setVote({ commit }, payload) {
      setTimeout(() => commit('SET_VOTE', payload), 3000);
    }
  }
});

export default store;